import * as Yup from 'yup';
import {messages} from '../../../common/Models/Validations';

export const userInitialValue = {
  email: '',
  museum_ids: [],
  role_ids: [],
  first_name: '',
  last_name: '',
  phone: '',
  cid: '',
  emp_id: '',
  profile: {
    agency: '',
    // dzongkhag_id: null,
    // gewog_id: null,
    // village_id: null
  }
};

export const userValidation = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email cant be blank*').nullable(),
  first_name: Yup.string().required(messages.required),
  phone: Yup.string().required(messages.required),
  cid: Yup.string()
    .transform((value) => (value === null || value === undefined ? '' : String(value)))
    .matches(/^\d+$/, {message: 'CID must contain only numbers', excludeEmptyString: true})
    .test('len', 'CID must be exactly 11 digits', val => !val || val.length === 11),
  // museum_ids: Yup.array()
  //   .of(Yup.string().required(messages.required))
  //   .required(messages.required),
});
